import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Shell } from './shell.service';
import { AuthenticationGuard } from '@app/auth';

import { ReportsComponent } from '@app/reports/reports.component';
import { PlaeneComponent } from '@app/plaene/plaene.component';
import { DokumenteComponent } from '@app/dokumente/dokumente.component';
import { SettingsComponent } from '@app/settings/settings.component';
import { DatenschutzComponent } from '@app/datenschutz/datenschutz.component';
import { ImpressumComponent } from '@app/impressum/impressum.component';
import { HelpComponent } from '@app/help/help.component';
import { SupportComponent } from '@app/support/support.component';

import { extract } from '@app/i18n';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'reports',
      canActivate: [AuthenticationGuard],
      component: ReportsComponent,
      data: { title: 'Reports' },
    },
    {
      path: 'plaene',
      canActivate: [AuthenticationGuard],
      component: PlaeneComponent,
      data: { title: 'Pläne' },
    },
    {
      path: 'dokumente',
      canActivate: [AuthenticationGuard],
      component: DokumenteComponent,
      data: { title: 'Dokumente' },
    },
    {
      path: 'settings',
      canActivate: [AuthenticationGuard],
      component: SettingsComponent,
      data: { title: extract('Settings') },
    },
    {
      path: 'datenschutz',
      canActivate: [],
      component: DatenschutzComponent,
      data: { title: extract('Datenschutz') },
    },
    {
      path: 'impressum',
      canActivate: [],
      component: ImpressumComponent,
      data: { title: extract('Impressum') },
    },
    { path: 'help', canActivate: [AuthenticationGuard], component: HelpComponent, data: { title: extract('Help') } },
    {
      path: 'support',
      canActivate: [AuthenticationGuard],
      component: SupportComponent,
      data: { title: extract('Support') },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ShellRoutingModule {}

